<template>
  <a-space style="flex-wrap: wrap">
    <a-input
      v-model:value="currentItem.params.keyword"
      placeholder="请输入关键字"
      allowClear
      @keydown.enter="searchGoods"
    />
    <a-button type="primary" class="search-btn" @click="searchGoods"
      ><SearchOutlined />搜索</a-button
    >
    <a-space style="font-size: 15px; white-space: nowrap; flex-wrap: wrap">
      <div>
        价格:
        <a-input
          v-model:value="currentItem.params.minPrice"
          placeholder="最小值"
          style="width: 100px"
          allowClear
          @pressEnter="searchGoods"
        />
        ~
        <a-input
          v-model:value="currentItem.params.maxPrice"
          placeholder="最大值"
          style="width: 100px"
          allowClear
          @pressEnter="searchGoods"
        />
      </div>
      <a-select
        v-model:value="currentItem.params.sort"
        placeholder="请选择排序"
        allowClear
        @change="searchGoods"
      >
        <a-select-option
          v-for="item in sortOptions"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </a-select-option>
      </a-select>
      <div v-if="currentItem.apiTag !== '1688platsuggest'">
        发货时效:
        <a-select
          v-model:value="currentItem.params.fhsx"
          placeholder="选择发货时效"
          allowClear
          @change="searchGoods"
        >
          <a-select-option
            v-for="item in fahuolvOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </div>
    </a-space>
  </a-space>
</template>
<script>
  import { SearchOutlined } from "@ant-design/icons-vue"
  import handler from '@/views/moving_function/views/select_goods/platform/1688/handler'
  import { LoadCategoryData } from '../../utils'
  export default {
    emits: ['searchGoods'],
    components: { SearchOutlined },
    data() {
      return {
        currentItem: {
          params: {},
          categoryList: [],
          typeOptions: []
        },
        fahuolvOptions: [
          { value: 24, label: '24小时发货' }, { value: 48, label: '48小时发货' }, { value: 72, label: '72小时发货' }
        ],
        sortOptions: [
          { value: 'MinPrice', label: '价格升序' }, { value: '-MinPrice', label: '价格降序' },
          { value: 'Fhsx', label: '发货时效升序' }, { value: '-Fhsx', label: '发货时效降序' }
        ]
      }
    },
    props: {
      params: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      searchGoods() {
        this.$emit('searchGoods')
      },
      // 级联框-搜索类目
      filterCategory(inputValue, path) {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
      },
      async getCategoryList() {
        if (!this.currentItem.categoryList?.length) {
          const { list } = await handler.GetCategoryList({})
          list.sort((a, b) => a.label.length - b.label.length)
          this.currentItem.categoryList = list
        }
      },
      loadCategoryData(selectedOptions) {
        LoadCategoryData(this, selectedOptions)
      },
      // 搜索-下拉列表
      filterSelect(input, option) {
        return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    mounted() {
      this.currentItem = this.params
      this.getCategoryList()
    },
    watch: {
      'params.value': {
        handler() {
          this.currentItem = this.params
        },
        immediate: true
      }
    }
  }
</script>
<style lang="less">
  .hide-icon.taote-category-cascader-popup {
    .ant-cascader-menu-item {
      .ant-cascader-menu-item-expand-icon {
        display: none;
      }
    }
  }
</style>